import axios from '@/api/axios';
import { gql } from '@/api/utils';

export default {
  async getProductByIDs(ids) {
    try {
      let query = gql`
        query {
      `;

      ids.map((id) => {
        query += gql`
          Product_${id}: product(id: ${id}) {
            id
            name
            price
            image {
              original
            }
            type
            ... on OtherProduct {
              discountedPrice
            }
            status
          }
        `;
      });

      query = query + gql`}`;

      return await axios.post(`/`, { query });
    } catch (error) {
      return Promise.reject({
        message: error.message,
      });
    }
  },
  async getProductsByTypes(types, cityId) {
    String.prototype.toProperCase = function () {
      return this.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    };

    try {
      let query = gql`
        query productsByType($cityId: ID!){
      `;

      types.map((type) => {
        query += gql`
          ${type?.toProperCase()}_Products: products(cityId: $cityId, type: ${type}) {
            id
            name
            price
            image {
              original
            }
            type
            ... on OtherProduct {
              discountedPrice
            }
          }
        `;
      });

      query = query + gql`}`;

      return await axios.post(`/`, { query, variables: { cityId } });
    } catch (error) {
      return Promise.reject({
        message: error.message,
      });
    }
  },
};
